(function () {
  if (customElements.get('youtube-facade')) return;

  class YoutubeFacade extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.load, { once: true });
    }

    load() {
      var videoId = this.dataset.videoId;
      if (!videoId) return;

      var thumbAlt = this.querySelector('img');
      var iframe = document.createElement('iframe');
      iframe.setAttribute('src', 'https://www.youtube-nocookie.com/embed/' + videoId + '?autoplay=1&rel=0');
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute(
        'allow',
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
      );
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('title', thumbAlt ? thumbAlt.alt : 'YouTube video player');

      this.innerHTML = '';
      this.appendChild(iframe);
    }
  }

  customElements.define('youtube-facade', YoutubeFacade);
})();
